export default {"src":"/_next/static/media/glasses.5b996c50.svg","height":91,"width":167};